/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

// import "../navigation/landing.css";
import React, {useState} from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
import {useNavigate} from "react-router-dom";
import {columns, data} from "../../data/AddUser-table.js";

import {LinearProgress, Skeleton} from '@mui/material';

// Returns: objects data table
export default function USERS() {
  const [open, setOpen] = useState(false)

  const navigate = useNavigate();
  const [nav, setNav] = React.useState(0);
  const [resultLength, setResultLength] = useState(0);
  // const [tableData, setTableData] = useState({});

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSyncing, setIsSyncing] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const tableData = {
    columns,
    data
  };
  const actions = (
    <div class="add-button">
    </div>
  );

  const ExpandableComponent = ({data}) => <DataTable
    onRowClicked={null}
    highlightOnHover
    noTableHead
    noHeader
    columns={columns}
    pointerOnHover
    striped
    defaultSortFieldId={13}
  />;


  return (
    <>
      <html lang="en"/>
      <div class="main-panel">
        <div class="table-page-background">
          {!isLoading ? <DataTableExtensions
              filterHidden={isError ? true : ''}
              filterPlaceholder="Search"
              filter={!isError}
              export={false}
              print={false}

              {...tableData}
            >
              <DataTable
                progressComponent={<LinearProgress color={!isError ? "inherit" : "warning"} sx={{
                  width: '100%'
                }}/>}
                defaultSortFieldId={3}
                keyField="id"
                expandOnRowClicked
                highlightOnHover
                striped
                actions={actions}
                fixedHeader
                fixedHeaderScrollHeight="650px"
                expandableRows
                expandableRowDisabled={row => !row.sub}
                expandableRowsComponent={ExpandableComponent}
                title={isError && "Error has occured, please refresh or contact support for assistance."}
                persistTableHead
                columns={columns}
                data={data}
              />
            </DataTableExtensions>
            : <Skeleton animation="wave" sx={{bgcolor: '#f2f5fa'}} height={625} variant="rectangular"/>}
        </div>
      </div>
    </>
  );
}